import { useCallback } from "react";
import { useAuth } from "@/context/AuthContext";

interface AuthHandlersProps {
  onSuccess: (userData?: { name?: string; email?: string }) => void;
}

export const useAuthHandlers = (
  auth: ReturnType<typeof useAuth>, 
  onSuccess: AuthHandlersProps['onSuccess']
) => {
  const handleLogin = useCallback(async (values: { email: string; password: string }) => {
    await auth.login(values.email, values.password);
  }, [auth]);

  const handleSignup = useCallback(async (values: { 
    name: string; 
    email: string; 
    password: string; 
    confirmPassword: string 
  }) => {
    try {
      await auth.signup(values.name, values.email, values.password);
      // Pass user data to onSuccess callback
      onSuccess({ name: values.name, email: values.email });
    } catch (error) {
      console.error("Signup error in AuthForm:", error);
    }
  }, [auth, onSuccess]);

  const handleSSOLogin = useCallback(async (provider: string) => {
    await auth.loginWithProvider(provider);
  }, [auth]);

  return { handleLogin, handleSignup, handleSSOLogin };
};